import { render, staticRenderFns } from "./Deleted.vue?vue&type=template&id=066f2abe&scoped=true"
import script from "./Deleted.vue?vue&type=script&lang=js"
export * from "./Deleted.vue?vue&type=script&lang=js"
import style0 from "./Deleted.vue?vue&type=style&index=0&id=066f2abe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f2abe",
  null
  
)

export default component.exports